import { render, staticRenderFns } from "./BaseFormGroupInputDateTime.vue?vue&type=template&id=b9e56af2"
import script from "./BaseFormGroupInputDateTime.vue?vue&type=script&lang=js"
export * from "./BaseFormGroupInputDateTime.vue?vue&type=script&lang=js"
import style0 from "./BaseFormGroupInputDateTime.vue?vue&type=style&index=0&id=b9e56af2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports